import { apiSlice } from '@/api'

export const cameraApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCameraLists: builder.query({
      query: () => ({
        url: 'api/v2/cameras',
        method: 'GET'
      }),
      providesTags: (result, _error, _arg) =>
        result && Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({ type: 'CameraLists', id })),
              'CameraLists'
            ]
          : ['CameraLists']
      // providesTags: (result, _error, _arg) =>
      //   result
      //     ? [
      //         ...result.map(({ id }) => ({ type: 'CameraLists', id })),
      //         'CameraLists'
      //       ]
      //     : ['CameraLists']
    }),
    createCamera: builder.mutation({
      query: ({ ...body }) => ({
        url: 'api/v2/cameras',
        method: 'POST',
        body
      }),
      invalidatesTags: ['CameraLists']
    }),
    updateCamera: builder.mutation({
      query: (body) => ({
        url: 'api/v2/cameras',
        method: 'PUT',
        body
      }),
      invalidatesTags: ['CameraLists']
    }),
    getListTypes: builder.query({
      query: () => ({
        url: 'api/v2/camera_types',
        method: 'GET'
      }),
      providesTags: ['CameraLists']
    })
  })
})

export const {
  useGetCameraListsQuery,
  useCreateCameraMutation,
  useUpdateCameraMutation,
  useGetListTypesQuery
} = cameraApi
